import { changeState, showLayers } from "components/ui-helper";
import FreeSpinsRecord from "integration/freespin-record";
import AllWinsMediators from "Mediator/all-wins-mediator";
import { StopAutoplayCommand } from "slotworks/commands/autoplay/stop-autoplay";
import { SetWinningsCommand } from "slotworks/commands/betbar/set-winnings-command";
import Components from "slotworks/components/components";
import GameState from "slotworks/model/game-state";
import gameState from "slotworks/model/game-state";
import Contract from "slotworks/utils/contract";
import { parallel } from "slotworks/utils/race-utils";
import GameInit from "states/game-init";
import { DOScenes, GameType } from "../names/do-names";

export function SetupFreespinsCommand(): Contract<void> {
    GameInit.gameType = GameType.freeSpin;
    GameInit.freeSpinLoaded = true;
    const functions: any = [];
    
    StopAutoplayCommand();
    let total;
    let remain;
    let totalWin;
    const records = GameState.getCurrentGame().getCurrentRecord();
    const freespinRecords = records.getResultsOfType(FreeSpinsRecord) as FreeSpinsRecord[];
    const freespinRecord = freespinRecords[0];
    total = freespinRecord?.freespinsWon || records.freespinsWon;
    totalWin = freespinRecord?.totalWinCash || 0;
    remain = freespinRecord ? freespinRecord.remainingFreespins - 1 : total - 1;
    changeState(DOScenes.FREESPIN);
    Components.betBar.setTotalFreespins(total);
    Components.betBar.setRemainingFreespins(remain);
    Components.betBar.setTotalWin(totalWin);
    Components.betBar.setEnabled(false);
    showLayers();
    SetWinningsCommand(0, totalWin);
    return parallel(functions);
}




// WEBPACK FOOTER //
// ./src/commands/setup-freespins-command.ts